import { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import ServiceCard from "@/components/ServiceCard";
import HowItWorks from "@/components/HowItWorks";
import Reviews from "@/components/Reviews";
import OrderTerminal from "@/components/OrderTerminal";
import PaymentSection from "@/components/PaymentSection";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Home() {
  const [confirmedOrder, setConfirmedOrder] = useState(null);
  const [config, setConfig] = useState({
    cashapp_handle: "$biipodmodding",
    delivery_minutes: 5,
    packages: [],
  });
  const [selectedPackageId, setSelectedPackageId] = useState(null);

  useEffect(() => {
    fetch(`${API}/config`)
      .then((r) => r.json())
      .then((c) => {
        setConfig(c);
        const featured = (c.packages || []).find((p) => p.featured);
        setSelectedPackageId(featured?.id || c.packages?.[0]?.id || null);
      })
      .catch(() => {});
  }, []);

  const selectPackageAndScroll = (id) => {
    setSelectedPackageId(id);
    setTimeout(() => {
      const el = document.getElementById("order");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  };

  const selectedPackage =
    (config.packages || []).find((p) => p.id === selectedPackageId) ||
    (config.packages || [])[0];
  const cheapest = (config.packages || []).reduce(
    (min, p) => (min === null || p.price < min ? p.price : min),
    null
  );

  return (
    <div className="relative min-h-screen bg-[#050505] text-zinc-100 selection:bg-[#ff6b00] selection:text-black">
      <Nav />
      <Hero fromPrice={cheapest} deliveryMinutes={config.delivery_minutes} />

      <section id="service" className="relative px-6 py-24 md:px-12 lg:px-20 border-t border-zinc-900">
        <ServiceCard
          packages={config.packages || []}
          deliveryMinutes={config.delivery_minutes}
          onSelect={selectPackageAndScroll}
        />
      </section>

      <section id="how" className="relative px-6 py-24 md:px-12 lg:px-20 bg-black border-t border-zinc-900">
        <HowItWorks />
      </section>

      <section id="reviews" className="relative px-6 py-24 md:px-12 lg:px-20 border-t border-zinc-900">
        <Reviews />
      </section>

      <section id="order" className="relative px-6 py-24 md:px-12 lg:px-20 border-t border-zinc-900">
        <div className="mx-auto mb-8 flex max-w-7xl items-start gap-3 border border-[#ff6b00]/40 bg-[#ff6b00]/5 px-5 py-4" data-testid="queue-notice">
          <span className="mt-0.5 font-display text-lg leading-none text-[#ff6b00]">⚠</span>
          <p className="font-hud text-sm text-zinc-200">
            <span className="font-mono-hud uppercase tracking-widest text-[#ff6b00]">Heads up: </span>
            The ~5 minute turnaround starts <span className="text-[#ff6b00]">once your order is picked up</span>. During high-volume windows orders may be slow to initiate — you'll get a Discord DM the moment Biipod starts on yours.
          </p>
        </div>
        <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-5">
          <div className="lg:col-span-3">
            <OrderTerminal
              apiUrl={API}
              packages={config.packages || []}
              selectedPackageId={selectedPackageId}
              onPackageChange={setSelectedPackageId}
              onSuccess={setConfirmedOrder}
              confirmed={confirmedOrder}
            />
          </div>
          <div className="lg:col-span-2">
            <PaymentSection
              cashappHandle={config.cashapp_handle}
              price={selectedPackage?.price || 0}
              packageName={selectedPackage?.name || ""}
              confirmed={confirmedOrder}
            />
          </div>
        </div>
      </section>

      <section id="faq" className="relative px-6 py-24 md:px-12 lg:px-20 bg-black border-t border-zinc-900">
        <FAQ />
      </section>

      <Footer cashappHandle={config.cashapp_handle} />
    </div>
  );
}
